// removed by extract-text-webpack-plugin
module.exports = {"card":"TrackedAsin__card__fUCVg","asin":"TrackedAsin__asin__1Qgvr","message":"TrackedAsin__message__JHAon","iframe":"TrackedAsin__iframe__2vXt7","p":"TrackedAsin__p__1zeca","button":"TrackedAsin__button__1U9_0","smallImage":"TrackedAsin__smallImage__VQ5oQ"};


//////////////////
// WEBPACK FOOTER
// ./src/TrackedAsins/TrackedAsin/TrackedAsin.css
// module id = 45
// module chunks = 0